import T from 'prop-types';
import React from 'react';
import MimeTypes from 'shared/helpers/mime-types';

export default class HiddenFileSelectButton extends React.Component {
  static propTypes = {
    onFileSelected: T.func,
    label: T.string,
  };

  static defaultProps = {
    onFileSelected: () => {},
    label: 'Replace',
  };

  onFileSelected = evt => {
    const file = evt.target.files[0];
    if (!file) {
      return;
    }
    if (MimeTypes.Audio.indexOf(file.type) > -1) {
      if (typeof this.props.onFileSelected === 'function') {
        this.props.onFileSelected(file);
      }
    }
  };

  triggerFileSelector = evt => {
    if (this.file) {
      this.file.click();
    }
    evt.preventDefault();
  };

  render() {
    const emptyValueToTriggerOnChangeForSameFile = '';

    return (
      <span>
        <input
          type="file"
          style={{
            display: 'none',
          }}
          accept={MimeTypes.Audio}
          value={emptyValueToTriggerOnChangeForSameFile}
          onChange={this.onFileSelected}
          ref={input => {
            this.file = input;
          }}
        />
        <button className="hidden-file-select-button" onClick={this.triggerFileSelector}>
          {this.props.label}
        </button>
      </span>
    );
  }
}
